import React from 'react';
import { TableLobby } from '@pascal/pascal-core';
import gameLogo from '../../assets/images/roulette-logo.png';

export const TableLobbyWr = () => {
  return <TableLobby hasFreeBets gameLogo={gameLogo} isShowGameTypeName />;
};
